import React from "react";
import { useMediaQuery } from "react-responsive";
import { Link, useLocation } from "react-router-dom";
import MobileHeader from "../MobileHeader/MobileHeader";
import "./Header.scss";
import { ReactComponent as Logo } from "../../../static/icons/logo-SaveOffice.svg";
import { performConversionScript } from "../../../shared/ConversionHelper";

interface HeaderProps {
  ctaText?: string;
  ctaPath?: string;
}

const Header = ({
  ctaText = "지금 신청하기",
  ctaPath = "/consult",
}: HeaderProps) => {
  const [collapse, setCollapse] = React.useState(false);

  const isMobile = useMediaQuery({
    query: "(max-width: 1200px)",
  });
  const location = useLocation();
  const logoPath = "/";

  React.useEffect(() => {
    if (isMobile) {
      return;
    }

    let scrollY = 0;

    function isVisible() {
      if (window.scrollY > scrollY) {
        setCollapse(true);
        scrollY = window.scrollY;
      } else {
        setCollapse(false);

        scrollY = window.scrollY;
      }
    }

    window.addEventListener("scroll", isVisible);
    return () => window.removeEventListener("scroll", isVisible);
  }, [isMobile]);

  return isMobile ? (
    <MobileHeader />
  ) : (
    <header className={`header ${collapse ? "collapse_" : ""}`} id={"header"}>
      <div className="gnb">
        <Link
          to={logoPath}
          className="logo"
          onClick={() => window.scrollTo({ top: 0 })}
        >
          <Logo />
        </Link>
        <nav className="nav">
          <ul>
            <li className="dropdown">
              <Link to="/">
                {/* styled with tailwindcss */}
                <div className="flex flex-row">
                  <div>비상주 사무실</div>
                  <img
                    className="ml-[10px] h-[8px] my-auto"
                    src={require("../../../static/bottom_chevron.png")}
                  />
                </div>
              </Link>
              <div className="dropdown-list">
                <div className="space" />
                <ul>
                  {/* <a href="/offer">제공 서비스</a> */}
                  <a href="/benefits">베네핏 서비스</a>
                  <a href="/price">비용 안내</a>
                  <a href="/manual">이용 방법</a>
                  <a href="/union">결합 서비스</a>
                  <Link to="/faq">자주 묻는 질문</Link>
                </ul>
              </div>
            </li>
            <li>
              <Link to="/private-office">상주 사무실</Link>
            </li>
            <li>
              <Link to="/location">위치 안내</Link>
            </li>
            <li>
              <Link to="/promotion">프로모션</Link>
            </li>
          </ul>
          <Link
            to={`${ctaPath}${location.search}`}
            className={`filled ${
              ctaText === "무료 투어 신청하기" ? " filled--wide" : ""
            }`}
            onClick={performConversionScript}
          >
            {ctaText}
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
